import styled from "styled-components"

export const YTSubscribeContainer = styled.div`
  display: inline-block;
  background-color: white;
  padding: 8px 8px 7px;
`